function PokemonCard({ id, name, img, rarity }) {
    return <div style={{display:'inline-block', margin:'10px'}}>
        <div><img alt={name} src={img} style={{maxWidth: '120px'}}/></div>
        <div>{id}</div>
        <div>{name}</div>
        <div>{rarity}</div>
    </div>
}

export default PokemonCard;